import styled from "styled-components";
import { ConfirmDialog } from "primereact";

import { theme } from "../../../../styles/theme";

export const TermsContainer = styled.div`
  height: 100%;
  padding: 0 1rem;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue900} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800} !important;
    border-radius: 0 !important;
  }
`;

export const SyncButton = styled.button<{ $resyncing?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: ${(props) => (props.$resyncing ? "#6b7280" : theme.colors.blue400)};
  color: ${() => theme.colors.white};
  border: none;
  border-radius: 8px;
  cursor: ${(props) => (props.$resyncing ? "not-allowed" : "pointer")};
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover:not(:disabled) {
    background-color: ${() => theme.colors.blue400};
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  svg {
    font-size: 16px;
    animation: ${(props) => (props.$resyncing ? "spin 1s linear infinite" : "none")};
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ConfirmDialogStyled = styled(ConfirmDialog)`
  max-width: 600px;
  .p-dialog-header {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-content {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-footer {
    background: ${theme.colors.darkBlue};
    font-family: ${theme.font.poppins};
    flex-direction: row-reverse;
  }
`;
